
import AppCustomTable from "@/components/common/CustomTable.vue";

import { Reminder } from "@/models/reminder";
import Vue from "vue";
import { ReminderService } from "@/services/reminder-service";


export default Vue.extend({
	data(){
		return {
			isSending: false
		};
	},
	props: {
		reminders: {
			type: Array as () => Reminder[]
		},
		selectedReminders: {
			type: Array as () => Reminder[]
		}
	},
	computed: {
		totalCost(): number {
			let total = 0;
			for (let reminder of this.reminders) {
				total += reminder.Cost;
			}
			return total;
		},
		totalOpen(): number {
			let total = 0;
			for (let reminder of this.reminders) {
				if (!reminder.Sale) continue;
				total += reminder.Sale.TotalOpen;
			}
			return total;
		},
	},
	methods: {
		async sendAutoReminders() {
			this.isSending = true;
			await ReminderService.sendAutoReminderList(this.selectedReminders);
			this.$emit("close");
			this.$wf.notify(this.$ct("send-auto-reminders-ok"), "success", 3000, "check");
			this.isSending = false;
		},
		close() {
			this.$emit("close");
		},
		toggleReminder(reminder: Reminder) {
			let index = this.selectedReminders.indexOf(reminder);
			if (index == -1) {
				this.selectedReminders.push(reminder);
			} else {
				this.selectedReminders.splice(index, 1);
			}
		},
		isReminderSelected(reminder: Reminder): boolean {
			return this.selectedReminders.indexOf(reminder) != -1;
		}
	},
	components: {
		AppCustomTable
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
